import axios from 'axios';
import store from '../../store/index';

export default {
	getNotifications() {
		return axios.get('/api/notifications/me');
	},
	fetchNotification(queryString) {
		return axios.get(`/api/notifications/search?${queryString}`);
	},
	fetchNotificationCountPerStatus(queryString) {
		return axios.get(`/api/notifications/status-count?${queryString}`);
	},
	getNotification(id) {
		return axios.get(`/api/notifications/${id}`);
	},
	setNotificationToRead(id) {
		return axios.patch(`/api/notifications/${id}?read=true`, {});
	},
};
